import { mutatorAction } from "satcheljs";
import { getConditionalFormattingStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import type { ConditionalFormattingScenario } from "../store/schema/ConditionalFormattingScenarioType";

const removeEntryFromRowToModificationMapMutator: (key: string, mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario) => void = mutatorAction("removeEntryFromRowToModificationMap", function removeEntryFromRowToModificationMap(key: string, mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario): void {
    getConditionalFormattingStore(mailboxInfo, scenario).rowToModificationsMap.delete(key);
});
export default removeEntryFromRowToModificationMapMutator;
